<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  name?: string
  size?: number
}>()

const profileFirstLetter = computed(() => {
  if (!props.name) 
    return ''

  return props.name.slice(0, 1).toUpperCase()
})
</script>

<template>
  <ElAvatar
    :size="size"
    class="!bg-primary text-white font-bold text-[10px] leading-[14px]"
  >
    {{ profileFirstLetter }}
  </ElAvatar>
</template>
